module.exports = __webpack_public_path__ + "img/French-Fries.397e2ad4.svg";